import { canInsertAt, insert } from '../helpers/utilities/site-nav/insert';
import application from 'application';

export function createHeaderAction(editor, getPath, handleClick) {
  function addHeader() {
    insert(editor, getPath(), { brandName: application.startupModule.data.name });
  }
  return { iconName: 'event-icon', label: 'Header', description: 'Add brand and navigation', keywords: ['header', 'navigation', 'menu', 'brand'], type: 'site-nav',
    onClick() { handleClick(addHeader); },
    isVisible() { return canInsertAt(editor, getPath()); }
  };
}
